module.exports = __webpack_public_path__ + "static/media/facebook.b8216bcb.svg";